<template>
  <div>
    <div class="pageMask" ></div>
    <div class="dowmDiv">
      <div class="downMe">
        <div style="text-align:center;color:#474747;padding:20px 0;font-weight:700" class="f20">下载云学APP查看更多内容</div>
        <img
              src="http://h5.shihua.com/static/yunxue/closed.png"
              style="width: 16px; height:16px;position:absolute;right:30px;top:20px"
              @click="hideMe"
            />
        <div class="flex-sb" style="border:1px solid #DCDCDC;padding:10px;width:576px;margin:0 auto">
          <div style="text-align: center">
            <img
              src="http://h5.shihua.com/static/yunxue/app.png"
              style="width: 272px; height: 272px"
              
            />
            <div>关注云学公众号</div>
          </div>
          <div style="text-align: center">
            <img
              src="http://h5.shihua.com/static/yunxue/gzh.png"
              style="width: 272px; height: 272px"
              @click="dialogVisible2 = true"
            />
            <div>下载云学APP</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      
    };
  },
  methods:{
    hideMe(){
      this.$emit('hideMe')
    }
  }
};
</script>
<style>
.pageMask {
  position: fixed;
  z-index: 9999;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}
.dowmDiv {
  position: fixed;
  z-index: 99999;
  left: 0;
  right: 0;
  top: 200px;
  bottom: 0;
}
.downMe {
  width: 642px;
  height: 407px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 10px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/showBox.vue